<template>
  <section :class="{ fontLoaded }">
    <h2 :style="{ color: questionTextColor }">{{ question }}</h2>
    <h3 v-if="description"
      class="description" :style="{ color: questionTextColor }">
      {{ description }}
    </h3>
  </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Question',
  props: {
  },
  computed: {
    ...mapState('poll', [
      'question',
      'description',
      'fontLoaded',
      'questionTextColor'
    ])
  }
};
</script>

<style scoped lang="scss">
section {
  flex: 0 0 auto;
  margin: 16px auto 0;
  z-index: 1;
}

.isHorizontal {
  section {
    padding-top: 15px;
    margin: 0 auto 10px auto;
  }

  h2 {
    font-size: var(--question-hor-fontsize);
  }
}

h2 {
  margin: 0;
  font-size: var(--question-fontsize);
  font-weight: var(--question-fontweight);
  color: var(--question-color);
  transition: all 500ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  text-align: center;
  opacity: 0;
}

.fontLoaded {

  h2 {
    opacity: 1;
  }

  .description {
    opacity: 1;
  }
}

.description {
  margin: 0;
  font-size: 15px;
  font-weight: var(--question-fontweight);
  color: var(--question-color);
  transition: all 500ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  text-align: center;
  opacity: 0;
  padding-top:10px;
}

.style-bbl,
.style-veev {

  section {
    margin: 0 auto 0 175px;
    padding: 0 0 0 24px;

    @media screen and (max-width: 768px) {
      margin-left: 64px;
      min-height: 57px;
      margin-right: 20px;
      margin-top: 10px;
    }

    h2 {

      @media screen and (max-width: 768px) {
        text-align: left;
      }
    }
  }
}

.style-cryms {
  h2 {
    @media screen and (max-width: 768px) {
      padding: 0 10px;
    }
  }
}
.style-covenant {
  .show-results h2 {
    display: none;
  }
  &.isHorizontal section {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 768px) {
  .style-covenant {
    h2 {
      font-size: 1.6em;
      line-height: 1em;
    }
  }
}
@media only screen and (max-width: 567px) {
  .style-covenant {
    h2 {
      font-size: 1.2rem;
      line-height: 1em;
    }
  }
}

</style>
